<!-- Spacer -->
<div
    class="hemro-vertical-navigation-item-wrapper"
    [ngClass]="item.classes?.wrapper"></div>
